// Profil de première visite : prénom, date de naissance, âge, fille/garçon
const KEY = "rav-profile";

export function getProfile() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
}

export function saveProfile(profile) {
  localStorage.setItem(KEY, JSON.stringify(profile));
}

export function computeAge(birthdate) {
  const birth = new Date(birthdate);
  if (Number.isNaN(birth.getTime())) return null;
  const now = new Date();
  let age = now.getFullYear() - birth.getFullYear();
  const m = now.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) age -= 1;
  return age >= 0 && age < 130 ? age : null;
}

// Majuscules automatiques : prénom/nom = 1re lettre majuscule + reste minuscules ; texte libre = 1re lettre majuscule
export const capName = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s);
export const capFirst = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

// Initiales du rond de profil : 1re lettre du prénom + 1re lettre du nom
export const initials = (prenom, nom) =>
  `${(prenom || "").trim().charAt(0)}${(nom || "").trim().charAt(0)}`.toUpperCase() || null;

// Cadrage mémorisé de la photo de profil (déplacement + zoom choisis dans l'éditeur)
export function avatarImgStyle(user) {
  const p = user?.photo_pos;
  if (!p || (!p.x && !p.y && (p.scale === 1 || !p.scale))) return {};
  return { transform: `translate(${p.x || 0}%, ${p.y || 0}%) scale(${p.scale || 1})` };
}

// Champs obligatoires de la fiche (tout sauf la photo) — exigés après un achat
export const PROFILE_REQUIRED = ["name", "last_name", "birthdate", "address_number", "address_street", "address_zip", "address_city", "phone_mobile"];
export const missingProfileFields = (user) => PROFILE_REQUIRED.filter((k) => !user?.[k]);

// Identifiant stable de l'appareil (compteur freemium avant connexion)
export function getDeviceId() {
  let id = localStorage.getItem("rav-device");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("rav-device", id);
  }
  return id;
}

const norm = (s) =>
  s
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim()
    .split(/[\s-]/)[0];

const FEMALE = new Set([
  "marie", "anne", "julie", "sophie", "claire", "emma", "lea", "chloe", "manon", "sarah", "laura",
  "pauline", "marine", "elise", "elodie", "aurelie", "celine", "sandrine", "valerie", "isabelle",
  "nathalie", "sylvie", "martine", "monique", "brigitte", "catherine", "francoise", "nicole",
  "jacqueline", "helene", "charlotte", "juliette", "alice", "jeanne", "louise", "mathilde", "lucie",
  "lena", "rose", "anna", "eva", "lina", "zoe", "agathe", "margaux", "elsa", "ines", "nina",
  "oceane", "romane", "ambre", "victoria", "emmy", "lily", "lola", "mia", "jade", "lou", "iris",
  "capucine", "marguerite", "victoire", "diane", "florence", "caroline", "emilie", "amelie",
  "stephanie", "virginie", "laetitia", "delphine", "sabrina", "jessica", "jennifer", "audrey",
  "marion", "estelle", "clara", "annaelle", "maelle", "celia", "alicia", "elena", "sara",
  "constance", "penelope", "gabrielle", "leonie", "margot", "suzanne", "rene", "yvette", "odette",
]);
const MALE = new Set([
  "jean", "pierre", "paul", "jacques", "michel", "philippe", "alain", "nicolas", "eric", "david",
  "julien", "thomas", "antoine", "hugo", "louis", "arthur", "jules", "gabriel", "leo", "raphael",
  "nathan", "lucas", "enzo", "mathis", "adam", "ethan", "noah", "mohamed", "karim", "olivier",
  "laurent", "frederic", "sebastien", "christophe", "stephane", "franck", "marc", "andre",
  "bernard", "daniel", "henri", "georges", "robert", "roger", "rene", "marcel", "guy", "yves",
  "pascal", "didier", "bruno", "jerome", "vincent", "maxime", "quentin", "romain", "florian",
  "alexis", "kevin", "dylan", "theo", "valentin", "guillaume", "matthieu", "xavier", "cyril",
  "samuel", "simon", "victor", "bastien", "remy", "axel", "edouard", "fernand", "gaston",
]);
// Prénoms épicènes : on pose toujours la question
const UNISEX = new Set([
  "camille", "claude", "dominique", "charlie", "swan", "louison", "sasha", "andrea", "noa",
  "morgan", "yannis", "mael", "kais", "eden", "loane", "alix", "marlow", "charly",
]);

// Retourne "fille", "garçon" ou null (doute → demander)
export function guessGender(prenom) {
  const n = norm(prenom || "");
  if (n.length < 2) return null;
  if (UNISEX.has(n)) return null;
  if (FEMALE.has(n)) return "fille";
  if (MALE.has(n)) return "garçon";
  return null;
}
